import React from 'react';

import { AuthSignupVerifierContext } from 'src/providers/AuthSignupVerifierProvider';

export const useAuthSignupVerifier = () => {
  return React.use(AuthSignupVerifierContext);
};
